module.exports = "/_next/static/files/ce9e2a056c8f66860d40d0ad4aa05c3b.png";